import { useEffect } from "react";

/**
 * Sets <title> and meta description per page (SPA — runs on route change).
 */
export function useSEO({ title, description, canonical }) {
    useEffect(() => {
        if (title) {
            document.title = title;
        }
        if (description) {
            let m = document.querySelector('meta[name="description"]');
            if (!m) {
                m = document.createElement("meta");
                m.setAttribute("name", "description");
                document.head.appendChild(m);
            }
            m.setAttribute("content", description);

            let og = document.querySelector('meta[property="og:description"]');
            if (og) og.setAttribute("content", description);

            let tw = document.querySelector('meta[name="twitter:description"]');
            if (tw) tw.setAttribute("content", description);
        }
        if (title) {
            let ogt = document.querySelector('meta[property="og:title"]');
            if (ogt) ogt.setAttribute("content", title);
            let twt = document.querySelector('meta[name="twitter:title"]');
            if (twt) twt.setAttribute("content", title);
        }
        if (canonical) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);

            let ogUrl = document.querySelector('meta[property="og:url"]');
            if (ogUrl) ogUrl.setAttribute("content", canonical);
        }
    }, [title, description, canonical]);
}

export const SITE =
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "");
